import styled from 'styled-components';
export const HeaderContainer = styled.header`
  width: 100%;
  height: ${_ref => {
  let {
    screenWidth,
    wrapperWidth
  } = _ref;
  return screenWidth < wrapperWidth + 152 ? 56 : 80;
}}px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0 12px;

  background: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme?.colors?.secondaryD1;
}};
`;
export const Content = styled.div`
  width: ${_ref3 => {
  let {
    screenWidth,
    wrapperWidth,
    hasReturnButton
  } = _ref3;
  return screenWidth < 752 ? '100%' : `${wrapperWidth + (hasReturnButton ? 76 : 0)}px`;
}};
  margin-left: ${_ref4 => {
  let {
    screenWidth,
    hasReturnButton,
    wrapperWidth
  } = _ref4;
  return screenWidth >= wrapperWidth + 152 && hasReturnButton ? '-76px' : '0px';
}};

  display: flex;
  align-items: center;
  justify-content: ${_ref5 => {
  let {
    screenWidth
  } = _ref5;
  return screenWidth < 752 ? 'center' : 'flex-start';
}};
`;
export const Title = styled.h1`
  color: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme?.colors?.neutralL5;
}};
  ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme?.fonts?.h4;
}};
  background: transparent;
  margin: ${_ref8 => {
  let {
    screenWidth,
    hasReturnButton,
    wrapperWidth
  } = _ref8;
  return !hasReturnButton ? '0' : screenWidth < wrapperWidth + 152 ? '0 0 0 -48px' : '0 0 0 12px';
}};
  text-align: ${_ref9 => {
  let {
    screenWidth,
    wrapperWidth
  } = _ref9;
  return screenWidth < wrapperWidth + 152 ? 'center' : 'left';
}};
  padding: ${_ref10 => {
  let {
    screenWidth,
    wrapperWidth,
    hasReturnButton
  } = _ref10;
  return screenWidth < wrapperWidth + 152 && hasReturnButton ? '0 12px 0 48px' : '0';
}};
  display: block;
  width: 100%;
  max-width: ${_ref11 => {
  let {
    wrapperWidth
  } = _ref11;
  return wrapperWidth;
}}px;
  pointer-events: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;